export const isCombinationDisabled = (selection, disabledCombos) => {
  if (!disabledCombos?.length) return false;

  return disabledCombos.some((rule) =>
    Object.entries(rule.combination).every(
      ([key, val]) => selection[key] === val
    )
  );
};
